export const FINANCING_FIELD_DISPLAY_MAP = {
  loanAmount: "Loan Amount",
  apr: "APR",
  term: "Term",
  monthlyPayment: "Monthly Payment",
  downPayment: "Down Payment",
  tradeInValue: "Trade-in Value",
  rebates: "Rebates",
  applicationStatus: "Application Status",
  lenderName: "Lender Name",
  applicationDate: "Application Date",
  nameOfLender: "Name of Lender",
  amountFinanced: "Amount Financed",
  buyRate: "Buy Rate",
  financeType: "Finance Type",
  status: "Status",
};

export const getFinancingFieldDisplay = (key) => {
  return FINANCING_FIELD_DISPLAY_MAP[key] || key;
};
